const navigation = [
  { name: "Elections Watch", href: "/" },
  // { name: "Paper", href: "/labs" },
  // { name: "About", href: "/about" },
];

export default navigation;
